module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "P_Heading_1",
    attrs: {
      "id": "auto_bookmark_toc_1"
    }
  }, [_c('span', [_vm._v("The Sun Still Rises")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Norm-NoIndent"
  }, [_vm._v("By Laura Bailo")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Erik’s father lived for Pamplona’s yearly festival and the running of the bulls. Now he’s gone, and Erik flies to Pamplona on a whim to see the festival his father loved—without booking a room first. He’s looking at sleeping on the ground until friendly David from the tourism office offers to share his home.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("When Erik realizes he trusts David, that he might even be willing to face his anxiety to get to know David better, he begins to understand what this trip could mean. Pamplona is even more beautiful when seen through David’s eyes, and Erik might have traveled around the world just to find himself. But can he hold on to his newfound confidence—and to David—when it’s time to go home?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("World of Love: Stories of romance that span every corner of the globe.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34a0e764","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0001.vue
// module id = 57
// module chunks = 0